import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchCreditCardTypeMutation } from '../../../services'
import { UspConfigurationCreditCardTypeViewResult } from '../../../models'
import PaymentCreditCardTypesTable from './components/PaymentCreditCardTypesTable'
import AddEditPaymentCreditCardTypeModal from './components/AddEditPaymentCreditCardTypeModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsPaymentCreditCardTypes = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCreditCardTypes, { data, isLoading }] = useSearchCreditCardTypeMutation()
  const [creditCardTypeData, setCreditCardTypeData] = useState<UspConfigurationCreditCardTypeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchCreditCardTypes({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCreditCardTypeData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Credit Card Types'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <PaymentCreditCardTypesTable
                      loading={isLoading}
                      data={creditCardTypeData}
                      setData={setCreditCardTypeData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditPaymentCreditCardTypeModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCreditCardTypeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsPaymentCreditCardTypes
